import React, { useEffect, useState } from 'react';
// import Datas from '../data/faq-event/faq-event.json';
import { Container, Row, Col, Button, Collapse } from 'react-bootstrap';
import { Styles } from "./styles/faqEvent.js";
import axios from 'axios';

function FaqEvent() {
    const [open, setOpen] = useState(false);

    const [featuresList, setFeaturesList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const getFeatures = async () => {
            try {
                const apiBaseUrl = process.env.REACT_APP_API_URL;

                if (!apiBaseUrl) {
                    throw new Error('API base URL is not configured.');
                }

                const res = await axios.get(`${apiBaseUrl}/real-fm/api/v1/community-features/find-all`);
                setFeaturesList(Array.isArray(res.data) ? res.data : []);
            } catch (err) {
                console.error(err);
                setError('Community features are temporarily unavailable.');
            } finally {
                setLoading(false);
            }
        }
        getFeatures();
    },[])

    return (
        <Styles>
            {/* Faq & Event */}
            <section className="event-faq-area">
                
                <Container>
                
                    <Row>
                        <Col className="mb-4">
                        <Button
                            onClick={() => setOpen(!open)}
                            aria-controls="example-collapse-text"
                            aria-expanded={open}
                            className="expand-btn"
                        >
                            {open ? "Collapse All" : "Expand All"}
                        </Button>
                        </Col>
                    </Row>
                    <Row>      
                    {loading && (
                        <Col md="12">
                            <div className="faq-empty-state">
                                <h4>Loading community features</h4>
                                <p>Retrieving the latest feature list for the portal.</p>
                            </div>
                        </Col>
                    )}

                    {!loading && error && (
                        <Col md="12">
                            <div className="faq-empty-state">
                                <h4>Feature content unavailable</h4>
                                <p>{error}</p>
                            </div>
                        </Col>
                    )}

                    {!loading && !error && featuresList && featuresList.length > 0 ? featuresList.map((faqData, i) => (
                        <Col md="6" key={i}>
                            <div className="faq-area">
                                <div className="faq-box">
                                    <div className="faq-item" >
                                        <button
                                            type="button"
                                            className={`accordion-button ${open ? 'active' : ''}`}
                                            onClick={() => setOpen(!open)}
                                        >
                                            <div className="accordion-icon">
                                                <i className="las la-plus"></i>
                                            </div>
                                            <p>{faqData.featureName}</p>
                                        </button>
                                        <Collapse in={open}>
                                            <div className="accordion-content">
                                                <p>{faqData.featureDesc}</p>
                                            </div>
                                        </Collapse>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    )) : !loading && !error ? (
                        <Col md="12">
                            <div className="faq-empty-state">
                                <h4>No feature available</h4>
                                <p>The community features list has not been published yet.</p>
                            </div>
                        </Col>
                    ) : null}
                    </Row>
                </Container>
            </section>
        </Styles>
    )
}

export default FaqEvent
